/**
 * @generated SignedSource<<0caf57d6ad1de375bff4c3ab2c273404>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DashboardQuery$variables = {};
export type DashboardQuery$data = {
  readonly dashboardFlights: {
    readonly " $fragmentSpreads": FragmentRefs<"DashboardFlightsCard_flightsInfo">;
  };
  readonly settings: {
    readonly " $fragmentSpreads": FragmentRefs<"DashboardFlightsCard_settings">;
  };
};
export type DashboardQuery = {
  response: DashboardQuery$data;
  variables: DashboardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DashboardFlightsInfo",
        "kind": "LinkedField",
        "name": "dashboardFlights",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DashboardFlightsCard_flightsInfo"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Settings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DashboardFlightsCard_settings"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DashboardQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DashboardFlightsInfo",
        "kind": "LinkedField",
        "name": "dashboardFlights",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "total",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalFailed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Flight",
            "kind": "LinkedField",
            "name": "failedFlights",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shortName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "departureDate",
                "storageKey": null
              },
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FlightPrice",
                "kind": "LinkedField",
                "name": "lastSuccessfulUpdate",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Settings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "flightsUpdaterEnabled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dbea89cc918aaaba55a0c874fa11be5c",
    "id": null,
    "metadata": {},
    "name": "DashboardQuery",
    "operationKind": "query",
    "text": "query DashboardQuery {\n  dashboardFlights {\n    ...DashboardFlightsCard_flightsInfo\n  }\n  settings {\n    ...DashboardFlightsCard_settings\n  }\n}\n\nfragment DashboardFlightsCardTable_flightsInfo on DashboardFlightsInfo {\n  failedFlights {\n    id\n    ...DashboardFlightsTableRow_flight\n  }\n}\n\nfragment DashboardFlightsCardUpdateStatus_flightsInfo on DashboardFlightsInfo {\n  totalFailed\n  ...DashboardFlightsCardTable_flightsInfo\n}\n\nfragment DashboardFlightsCardUpdateStatus_settings on Settings {\n  flightsUpdaterEnabled\n}\n\nfragment DashboardFlightsCard_flightsInfo on DashboardFlightsInfo {\n  total\n  ...DashboardFlightsCardUpdateStatus_flightsInfo\n}\n\nfragment DashboardFlightsCard_settings on Settings {\n  ...DashboardFlightsCardUpdateStatus_settings\n}\n\nfragment DashboardFlightsTableRow_flight on Flight {\n  id\n  shortName\n  departureDate\n  createdAt\n  updatedAt\n  lastSuccessfulUpdate {\n    createdAt\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b0d35a9bb475303f99f5fd0b846ef262";

export default node;
